import React from "react";
import SheetUpload from "../../images/sheet-upload.png";
import UploadIcon from "../../svgs/upload-file.svg";
import DownloadIcon from "../../svgs/download-file.svg";
import CloseIcon from "@mui/icons-material/Close";

const FileUpload = ({
  uploadedFile = null,
  handleFileChange,
  handleFileUpload,
  handleDownloadSample,
  acceptedFileTypes = ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
  hints = [],
  isDisabled = false,
  isUploading = false,
  isDownloading = false,
  setUploadedFile = null,
  uploadTitle = "Upload Device List",
  uploadSubtitle = "(Serial Numbers only)",
  mappingFields = [],
  mappingNote = "",
  showMappingLayout = false,
  fileInputId = "bulk-upload-file",
}) => {
  const fileInputRef = React.useRef(null);

  const triggerFileUpload = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (fileInputRef.current && !isUploading && !isDisabled && !isDownloading) {
      fileInputRef.current.click();
    }
  };

  const handleDownloadUploadedFile = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (uploadedFile) {
      if (typeof uploadedFile === "string") {
        window.open(uploadedFile, "_blank");
      } else if (uploadedFile instanceof File) {
        const url = URL.createObjectURL(uploadedFile);
        const link = document.createElement("a");
        link.href = url;
        link.download = uploadedFile.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    }
  };

  const handleDeleteFile = () => {
    if (setUploadedFile && !isUploading && !isDisabled && !isDownloading) {
      setUploadedFile(null);
    }
  };

  return (
    <div className="bulk-upload-section">
      <div className="upload-area">
        {showMappingLayout ? (
          <div className="upload-layout">
            <div className="upload-icon-container">
              <img
                src={SheetUpload}
                alt="Upload"
                className="upload-main-icon"
              />
            </div>
            <div className="upload-content">
              <h4 className="upload-title">{uploadTitle}</h4>
              {mappingFields.length > 0 && (
                <div className="mapping-list">
                  {mappingFields.map((field, index) => (
                    <div key={index} className="mapping-item">
                      <span className="mapping-number">{index + 1}.</span>
                      <span className="mapping-text">{field}</span>
                    </div>
                  ))}
                </div>
              )}
              {mappingNote && <p className="mapping-note">{mappingNote}</p>}
            </div>
          </div>
        ) : (
          <div className="upload-info-container">
            <img src={SheetUpload} alt="Upload" className="upload-main-icon" />
            <div className="upload-info">
              <h4>{uploadTitle}</h4>
              <p>{uploadSubtitle}</p>
            </div>
          </div>
        )}

        <div className="upload-buttons">
          <button
            type="button"
            className="upload-file-btn"
            onClick={
              uploadedFile ? handleDownloadUploadedFile : triggerFileUpload
            }
            disabled={isUploading || isDisabled || isDownloading}
          >
            {isUploading ? (
              <>
                <div className="upload-loader-small"></div>
                Uploading...
              </>
            ) : (
              <>
                <img
                  src={uploadedFile ? DownloadIcon : UploadIcon}
                  alt={uploadedFile ? "Download" : "Upload"}
                  className="btn-icon"
                />
                {uploadedFile ? "Download" : "Upload"}
              </>
            )}
          </button>
          <button
            type="button"
            className="sample-file-btn"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleDownloadSample();
            }}
            disabled={isDownloading || isDisabled}
          >
            {isDownloading ? (
              <>
                <div className="upload-loader-small"></div>
                Downloading...
              </>
            ) : (
              <>
                <img src={DownloadIcon} alt="Download" className="btn-icon" />
                Sample File
              </>
            )}
          </button>
        </div>
      </div>

      <input
        ref={fileInputRef}
        id={fileInputId}
        type="file"
        accept=".xlsx,.xls,.csv"
        style={{ display: "none" }}
        onChange={handleFileUpload}
        onClick={(e) => e.stopPropagation()}
      />

      {uploadedFile && (
        <div className="uploaded-file-info">
          <div className="file-info-container">
            <span>Uploaded: {uploadedFile.name || "File uploaded"}</span>
            {setUploadedFile && (
              <button
                type="button"
                className="delete-file-btn"
                onClick={handleDeleteFile}
                disabled={isUploading || isDisabled || isDownloading}
                title="Remove file"
              >
                <CloseIcon
                  style={{
                    color: "#FF0000",
                    height: "14px",
                    width: "14px",
                  }}
                />
              </button>
            )}
          </div>
        </div>
      )}

      {hints.length > 0 && (
        <div className="upload-hints">
          <ol>
            {hints.map((hint, index) => (
              <li key={index}>{hint}</li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
